var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublishedProcurementsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.673 41.2917L13.003 37.8034L9.89765 29.6571C9.67469 29.0696 9.65911 28.4234 9.85347 27.8258C10.0478 27.2281 10.4405 26.7148 10.9664 26.3707L18.2636 21.6059L20.5406 13.1925C20.7051 12.5857 21.0722 12.0535 21.5809 11.6841C22.0896 11.3147 22.7093 11.1304 23.3372 11.1618L32.0416 11.6042L38.8281 6.12683C39.3179 5.73187 39.9282 5.51649 40.5574 5.51649C41.1866 5.51649 41.7969 5.73187 42.2867 6.12683L49.0733 11.6042L57.7776 11.1707C58.4055 11.1393 59.0252 11.3236 59.5339 11.693C60.0426 12.0624 60.4097 12.5946 60.5742 13.2014L62.8512 21.6148L70.1484 26.3796C70.6748 26.7233 71.0678 27.2366 71.2622 27.8344C71.4566 28.4322 71.4407 29.0785 71.2172 29.666L68.1148 37.8123L71.2172 45.9556C71.4409 46.5435 71.4569 47.1903 71.2625 47.7886C71.0681 48.3869 70.675 48.9008 70.1484 49.245L62.8512 53.995L60.5623 62.4114C60.3989 63.0189 60.0322 63.5522 59.5233 63.9222C59.0145 64.2922 58.3942 64.4767 57.7658 64.4449L49.0614 64.0115L42.2748 69.477",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60156 61.9809L9.51781 69.7264",
    stroke: "#E5E7EB",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7896 27.4781L50.4749 56.9162",
    stroke: "#E5E7EB",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4918 55.3665L8.53492 68.1796L5.58398 63.5306L32.7718 29.0278L49.4918 55.3665Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3848 65.4098L19.9854 69.4057C20.4154 70.1107 20.985 70.7203 21.6591 71.1972C22.3332 71.674 23.0977 72.0081 23.9056 72.1788C24.7136 72.3495 25.5478 72.3532 26.3573 72.1898C27.1667 72.0264 27.9342 71.6993 28.6126 71.2285C29.9995 70.2304 30.9525 68.7399 31.2765 67.0622C31.6004 65.3844 31.2709 63.6463 30.3552 62.2035L29.8713 61.5029",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedProcurementsIcon);
export default __webpack_public_path__ + "static/media/publishedProcurementsIcon.1278380481488ab539c752cda9630682.svg";
export { ForwardRef as ReactComponent };